import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

const Navbar = ({ isScrolled }: NavbarProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/c711f717497a56c08cc09e92d692fa12.png"
              alt="Finance Planning Wealth Logo"
              className={`h-16 w-auto transition-all duration-300 ${
                isScrolled ? 'opacity-100' : 'opacity-90 drop-shadow-lg'
              }`}
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('approach')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              Our Approach
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F5A623]' : 'text-white hover:text-[#F5A623]'
              }`}
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#F5A623] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#E09612] transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-md cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('approach')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              Our Approach
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#F5A623] py-2 cursor-pointer"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#F5A623] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#E09612] transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
